import { on as delegate, $, $$ } from '../lib/dom';
import { setQuery, goBack } from '../lib/router';
import * as store from '../store/ui';
import { openPalette } from '../components/palette';
export function bindGlobal(render: () => void) {
  const controller = new AbortController();
  const cleanups: Array<() => void> = [];
  const on = (...args: Parameters<typeof delegate>) => { const cleanup = delegate(...args); cleanups.push(cleanup); };
  const previewError = (event: Event) => {
    const image = event.target;
    if (!(image instanceof HTMLImageElement) || !image.matches('[data-media-preview]')) return;
    const source = image.getAttribute('src') || '';
    if (/^\/api\/v1\/files\/[0-9a-f-]{36}\/preview$/i.test(source) && !image.dataset.contentRetry && !image.hasAttribute('data-thumbnail-only')) {
      image.dataset.contentRetry = '1'; image.src = source.replace(/preview$/, 'content');
    } else image.parentElement?.classList.add('media-unavailable');
  };
  document.addEventListener('error', previewError, { capture: true, signal: controller.signal });
  const videoCover = (video: HTMLVideoElement) => {
    if (!video.matches('[data-video-cover]') || video.dataset.coverReady || !Number.isFinite(video.duration) || video.duration <= 0) return;
    // The middle avoids both blank entrance frames and the animated exit.
    video.dataset.coverReady = '1';
    video.currentTime = video.duration / 2;
  };
  document.addEventListener('loadedmetadata', event => {
    if (event.target instanceof HTMLVideoElement) videoCover(event.target);
  }, { capture: true, signal: controller.signal });
  document.addEventListener('error', event => {
    if (event.target instanceof HTMLVideoElement && event.target.matches('[data-video-cover]')) event.target.parentElement?.classList.add('media-unavailable');
  }, { capture: true, signal: controller.signal });
  document.querySelectorAll<HTMLVideoElement>('[data-video-cover]').forEach(video => {
    if (video.readyState >= 1) videoCover(video);
    if (video.error) video.parentElement?.classList.add('media-unavailable');
  });
  // Catch already-failed cached images when the handlers mount after rendering.
  document.querySelectorAll<HTMLImageElement>('[data-media-preview]').forEach(image => {
    if (image.complete && !image.naturalWidth) image.parentElement?.classList.add('media-unavailable');
  });
  on(document, 'click', '[data-back]', (event, element) => {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault(); goBack(element.getAttribute('href') || '#/');
  });
  // Row links (tables) — anchors handle themselves
  on(document, 'click', '[data-href]', (e, el) => {
    if (e.target.closest('a, button, input, select')) return;
    location.hash = el.dataset.href.replace(/^#/, '');
  });
  on(document, 'click', '[data-fav]', (e, el) => {
    e.preventDefault(); e.stopPropagation();
    const [type, id] = el.dataset.fav.split(':');
    store.toggleFavorite(type, id);
    render();
  });
  // Query-param driven UI: tabs, views, filters
  on(document, 'click', '[data-tab]', (e, el) => { if (el.closest('[data-local-tabs]')) return; setQuery({ tab: el.dataset.tab }); render(); });
  on(document, 'click', '[data-view]', (e, el) => { if (el.closest('[data-local-tabs]')) return; setQuery({ view: el.dataset.view }); render(); });
  on(document, 'click', '[data-param]', (e, el) => { setQuery({ [el.dataset.param]: el.dataset.value || null }); render(); });
  let debounce: ReturnType<typeof setTimeout>;
  on(document, 'input', 'input[data-filter]', (e, el) => {
    if (el.closest('[data-local-tabs]')) return;
    clearTimeout(debounce);
    debounce = setTimeout(() => { setQuery({ [el.dataset.filter]: el.value || null }); render(); }, 140);
  });
  on(document, 'change', 'select[data-filter]', (e, el) => {
    if (el.closest('[data-local-tabs]')) return;
    setQuery({ [el.dataset.filter]: el.value || null }); render();
  });
  // Menus
  document.addEventListener('click', (e: any) => {
    const toggle = e.target.closest('[data-menu-toggle]');
    $$('.menu[data-menu]').forEach((m) => { if (!toggle || m.dataset.menu !== toggle.dataset.menuToggle) m.hidden = true; });
    if (toggle) { const m = $(`.menu[data-menu="${toggle.dataset.menuToggle}"]`); if (m) m.hidden = !m.hidden; }
  }, { signal: controller.signal });
  on(document, 'click', '[data-set-ws]', (e, el) => { store.set({ workspaceId: el.dataset.setWs || null }); render(); });
  on(document, 'click', '[data-set-theme]', (e, el) => { store.set({ theme: el.dataset.setTheme }); render(); });
  on(document, 'click', '[data-reset-demo]', () => { store.resetUi(); location.reload(); });
  on(document, 'click', '[data-open-palette]', () => openPalette());
  document.addEventListener('keydown', (e) => {
    if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') { e.preventDefault(); openPalette(); }
  }, { signal: controller.signal });
  return () => { clearTimeout(debounce); controller.abort(); cleanups.forEach(cleanup => cleanup()); };
}
